import { setTerms } from './helpers';

export const setBuildingClassType = setTerms('building_class_type');
